export let formataDataWebMethodParaDate = (dataASPNETWebMethod) => {
    if (!dataASPNETWebMethod) {
        return null;
    }
    //webapi
    if(dataASPNETWebMethod.indexOf("T") > 0){
        return new Date(dataASPNETWebMethod);
    }
    //mvc ou webmethod
    return new Date(+(dataASPNETWebMethod.replace(/\/Date\(/gim, "").replace(/(\)|\/)/gim, "")));
}

export let formataDataWebMethodParaString = (dataASPNETWebMethod) => {
    if (!dataASPNETWebMethod) {
        return "";
    }
    var d = formataDataWebMethodParaDate(dataASPNETWebMethod);

    var dia = d.getDate();
    var mes = d.getMonth() + 1;

    if (dia < 10) {
        dia = "0" + dia;
    }

    if (mes < 10) {

        mes = "0" + mes;
    }

    return dia + "/" + mes + "/" + d.getFullYear();

}

//yyyy-MM-dd
export let formataDataWebMethodParaStringHTML5 = (dataASPNETWebMethod) => {
    if (!dataASPNETWebMethod) {
        return "";
    }
    var d = formataDataWebMethodParaDate(dataASPNETWebMethod);

    var dia = d.getDate();
    var mes = d.getMonth() + 1;

    if (dia < 10) {
        dia = "0" + dia;
    }

    if (mes < 10) {

        mes = "0" + mes;
    }

    return d.getFullYear() + "-" + mes + "-" + dia;

}
//yyyy-MM-dd -> dd/MM/yyyy
export let formataDataHTML5ParaDDMMYYYY = (dataHTML5) => {

    if (!dataHTML5) {
        return "";
    }

    return dataHTML5.split("-").reverse().join("/");

}

export let formataDataDDMMYYYYParaHTML5 = (dataDDMMYYYY) => {

    if (!dataDDMMYYYY) {
        return "";
    }

    return dataDDMMYYYY.split("/").reverse().join("-");

}

export let converteStringDataDDMMYYYYParaDate = (dataDDMMYYYY) => {

    if (!dataDDMMYYYY) {
        return new Date();
    }
    var temp = dataDDMMYYYY.split("/");
    var dia = Number(temp[0]);
    var mes = Number(temp[1]);
    var ano = Number(temp[2]);
    return new Date(ano, mes - 1, dia)

}


export let mascaraCelular9Digito = (v) => {
    if(!v){
        return "";
    }
    v = v.replace(/\D/g, "");             //Remove tudo o que não é dígito
    if (v.length >= 11) {
        v = v.substring(0, 11);
    }
    v = v.replace(/^(\d{2})(\d)/g, "($1)$2"); //Coloca parênteses em volta dos dois primeiros dígitos
    v = v.replace(/(\d)(\d{4})$/, "$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos

    return v;

}

export let getQueryString = function (nome) {
    nome = nome.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + nome + "=([^&#]*)"),
        results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};




export let yearDifference = (date) => {
    "use strict";
    var curDate = new Date(),
        now = {
            year: curDate.getUTCFullYear(),
            // UTC month value is zero-based
            month: curDate.getUTCMonth(),
            day: curDate.getUTCDate()
        },
        diff = now.year % date.getUTCFullYear();

    // Do not update the date unless it is time
    if (now.month < date.getUTCMonth() ||
        now.month === date.getUTCMonth() && now.day < date.getUTCDate()) {
        diff -= 1;
    }

    return diff;
}



